import ApiService from '@/core/services/api.service';
import { makeToastSuccess, handleError } from '@/utils/common';
const BASE = 'v1/warranty-outsource';

export const getOutsourceList = async (params) => {
  try {
    const response = await ApiService.query(BASE, { params });
    return response.data?.data || { dataset: [], totalRow: 0, totalPage: 1 };
  } catch (err) {
    handleError(err);
    return { dataset: [], totalRow: 0, totalPage: 1 };
  }
};

export const getOutsourceById = async (id) => {
  try {
    const response = await ApiService.get(`${BASE}/${id}`);
    return response.data?.data ?? null;
  } catch (err) {
    handleError(err);
    return null;
  }
};

export const checkHasActiveOutsource = async (warrantyId) => {
  if (!warrantyId) return false;
  try {
    const response = await ApiService.get(`${BASE}/check-active`, {
      params: { warrantyId },
    });
    const data = response.data?.data;
    return data?.hasActive === true;
  } catch {
    return false;
  }
};

export const createOutsource = async (payload) => {
  try {
    const response = await ApiService.post(BASE, payload);
    const message = response.data?.message;
    if (message) makeToastSuccess(message);
    return response.data?.data;
  } catch (err) {
    handleError(err);
    throw err;
  }
};

export const updateOutsource = async (id, payload) => {
  try {
    const response = await ApiService.put(`${BASE}/${id}`, payload);
    const message = response.data?.message;
    if (message) makeToastSuccess(message);
    return response.data?.data;
  } catch (err) {
    handleError(err);
    throw err;
  }
};

export const receiveOutsource = async (id, payload) => {
  try {
    const response = await ApiService.put(`${BASE}/${id}/receive`, payload);
    const message = response.data?.message;
    if (message) makeToastSuccess(message);
    return response.data?.data;
  } catch (err) {
    handleError(err);
    throw err;
  }
};

// Provider search được xử lý bởi SupplierAutosuggest qua searchCustomers utility
